import { usePrintableWorksheetsState } from 'printableWorksheets/state'
import React, { useMemo, useState } from 'react'
import { WorksheetsEnvironment } from '../..';
import { DeviceTypes, useAppMediaProvider } from '../../../baseStyles/AppMediaProvider';
import { WSSearch }  from './wsSearch';

interface IWSHeaderProps {
    hideSearch: boolean;
}

const WSHeader: React.FC<IWSHeaderProps> = ({hideSearch = false}) => {

    const { activeNode , activeGrade,  activeBreadcrumb, setActiveBreadcrumb, subjectCode, worksheetSearchValue, userId, defaultSearch, setDefaultSearch, worksheetsEnvironment} = usePrintableWorksheetsState();
    const { currentDevice } = useAppMediaProvider();
    const [showHeader, toggleHeader] = useState<boolean>(true);

    const toggleDefaultSearch = (value: boolean) => {
        setDefaultSearch(value);
        value ? toggleHeader(true) : toggleHeader(false);
    }

    const renderBreadcrumbs = useMemo(() => (
        <>
        {
            activeBreadcrumb.map((node: any, index: any) => {
                return (
                    <React.Fragment key={node?.id}>
                        {index !== 0 ? <>&nbsp;{worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD ? `/` : `>`}&nbsp;</> : null}
                        <div className="breadcrumbs__item" onClick={() => {
                            let index = activeBreadcrumb.findIndex(bc=> bc.id === node.id);
                            setActiveBreadcrumb(activeBreadcrumb.slice(0, index + 1));   
                        }}>
                            {node?.title}
                        </div>
                    </React.Fragment>
                )
            })
        }
        </>
    ), [activeBreadcrumb])

    return (
        <div className={`ws-new-header ${!defaultSearch ? "increase-width" : ""}`} id="ws-header">
            {showHeader &&
                (
                    <div className={`ws-new-header__active-topic${currentDevice === DeviceTypes.Mobile ? ' mobile-header' : ''}`}>
                        <div className={`breadcrumbs${worksheetsEnvironment === WorksheetsEnvironment.STUDENT_DASHBOARD ? ' student' : ''}`}>
                            {renderBreadcrumbs}
                        </div>
                        { (worksheetsEnvironment !== WorksheetsEnvironment.TEACHER_DASHBOARD || activeNode?.children?.length === 0) ?
                         <div className={`topic${worksheetsEnvironment === WorksheetsEnvironment.STUDENT_DASHBOARD ? ' student' : ''}`}>
                            {`${activeNode?.title ? `${activeNode.title} Worksheets` : ''}`}
                        </div> : null
                        }
                    </div>
                )
            }

            {!hideSearch ? 
            <div className={`ws-new-header__searchbox ${!defaultSearch ? "increase-width" : ""}`}>
                <WSSearch
                    defaultSearch={defaultSearch}
                    subjectCode = {subjectCode}
                    toggleDefaultSearch = {toggleDefaultSearch}
                    worksheetSearchValue = {worksheetSearchValue}
                    gradeCode={activeGrade}
                    userId={userId}
                    searchPlaceholder={`Search Printables...`}
                />
            </div> : null}
        </div>
    ) 
}

export default WSHeader